// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c5d059e1","513":"5ac97c99","787":"36badb1a"}[chunkId] + ".chunk.js";
};